import { Link } from "react-router-dom";
import { ArrowRight, Compass } from "lucide-react";

const JourneyNudge = ({ context = "general" }) => {
  const messages = {
    general: {
      label: "Continue Growing",
      title: "Ready to go deeper?",
      text: "Explore our handpicked EQ and mindfulness resources — trusted tools to take your wellness journey further.",
    },
    after_purchase: {
      label: "Your Next Step",
      title: "What comes next?",
      text: "You've taken a powerful step. These curated resources will help you deepen your practice and build lasting emotional intelligence.",
    },
    after_ebook: {
      label: "Keep The Momentum",
      title: "Loved the ebook?",
      text: "These resources dive even deeper into emotional intelligence and wellness — handpicked to complement what you've just read.",
    },
    from_products: {
      label: "Go Further",
      title: "Beyond our offerings",
      text: "We've curated the best EQ books, courses, and tools to continue your growth journey. Every recommendation is something we genuinely trust.",
    },
  };

  const msg = messages[context] || messages.general;

  return (
    <div
      data-testid={`journey-nudge-${context}`}
      className="rounded-2xl p-6 md:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5 transition-all duration-500 hover:-translate-y-0.5"
      style={{
        background: "linear-gradient(135deg, rgba(163,184,153,0.12), rgba(247,208,70,0.08))",
        border: "1px solid var(--ll-border)",
      }}
    >
      <div className="flex items-start gap-4 flex-1">
        <div
          className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5"
          style={{ background: "var(--ll-bg-secondary)" }}
        >
          <Compass size={18} style={{ color: "var(--ll-green)" }} />
        </div>
        <div>
          <p
            className="text-[10px] tracking-[0.2em] uppercase mb-1"
            style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}
          >
            {msg.label}
          </p>
          <p
            className="text-sm font-medium mb-1"
            style={{ color: "var(--ll-text)", fontFamily: "'Outfit', sans-serif" }}
          >
            {msg.title}
          </p>
          <p
            className="text-xs leading-relaxed"
            style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}
          >
            {msg.text}
          </p>
        </div>
      </div>

      <Link
        to="/resources"
        data-testid={`journey-nudge-cta-${context}`}
        className="rounded-full px-6 py-2.5 text-xs font-medium transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg flex items-center gap-1.5 flex-shrink-0"
        style={{ background: "var(--ll-cta)", color: "var(--ll-cta-text)", fontFamily: "'Outfit', sans-serif" }}
      >
        Explore Resources <ArrowRight size={12} />
      </Link>
    </div>
  );
};

export default JourneyNudge;
